export { default } from './ItemAddedToShelfView';



// WEBPACK FOOTER //
// ./app/components/shared/ItemAddedToShelfView/index.js